import { FC } from 'react'

import { Token } from '@revolut-internal/ui-kit'

import { TEXT_SIZE } from 'modules/Monitoring/consts/chart'
import { formatNumber } from 'modules/Monitoring/utils/formatNumber'

type LineChartLabelProps = {
  color: string
  x?: number | string
  y?: number | string
  value?: unknown
}

export const LineChartLabel: FC<LineChartLabelProps> = props => {
  const { x, y, color, value } = props

  if (
    (typeof x !== 'number' && typeof x !== 'string') ||
    (typeof y !== 'number' && typeof y !== 'string') ||
    typeof value !== 'number'
  ) {
    return null
  }

  return (
    <text
      fill={color}
      x={x}
      y={y}
      dy={-8}
      textAnchor="middle"
      fontSize={TEXT_SIZE}
      fontWeight={500}
      stroke={Token.color.background}
      paintOrder="stroke"
      strokeWidth="1px"
      strokeLinecap="butt"
      strokeLinejoin="miter"
      pointerEvents="none"
    >
      {formatNumber(value)}
    </text>
  )
}
